import {
  Link,
  Sidebar,
  sidebarConfig,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
  useSidebarOpenState,
} from '@backstage/core-components';
import SearchIcon from '@material-ui/icons/Search';
import MenuIcon from '@material-ui/icons/Menu';
import GroupIcon from '@material-ui/icons/People';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import { MyGroupsSidebarItem } from '@backstage/plugin-org';
import { makeStyles } from '@material-ui/core/styles';
import LogoFull from '../components/logos/LogoFull';
import LogoIcon from '../components/logos/LogoIcon';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};

export const appModuleNav = createFrontendModule({
  pluginId: 'app',
  extensions: [
    NavContentBlueprint.make({
      params: {
        component: ({ items }) => {
          // Global nav items (not org-specific)
          const globalNavPaths = [
            '/',
            '/catalog',
            '/docs',
            '/create',
            '/api-docs',
          ];
          // Bottom-fixed nav items (settings area)
          const bottomNavPaths = ['/settings'];

          // hidden nav items (not rendered in the sidebar, but still accessible if needed)
          const hiddenNavPaths = ['/search'];

          const mainItems = items.filter(item =>
            globalNavPaths.includes(item.to),
          );
          // Extra items go into the scrollable area
          const extraItems = items.filter(
            item =>
              !globalNavPaths.includes(item.to) &&
              !bottomNavPaths.includes(item.to) &&
              !hiddenNavPaths.includes(item.to),
          );
          // Bottom-fixed items rendered alongside Settings
          const bottomItems = items.filter(item =>
            bottomNavPaths.includes(item.to),
          );

          return (
            <Sidebar>
              <SidebarLogo />
              <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
                <SidebarSearchModal />
              </SidebarGroup>
              <SidebarDivider />
              <SidebarGroup label="Menu" icon={<MenuIcon />}>
                {/* Global nav, not org-specific */}
                {mainItems.map(item => (
                  <SidebarItem
                    key={item.to}
                    icon={item.icon}
                    to={item.to}
                    text={item.text}
                  />
                ))}
                <MyGroupsSidebarItem
                  singularTitle="My Group"
                  pluralTitle="My Groups"
                  icon={GroupIcon}
                />
                {/* End global nav */}
                <SidebarDivider />
                <SidebarScrollWrapper>
                  {extraItems.map(item => (
                    <SidebarItem
                      key={item.to}
                      icon={item.icon}
                      to={item.to}
                      text={item.text}
                    />
                  ))}
                </SidebarScrollWrapper>
              </SidebarGroup>
              <SidebarSpace />
              <SidebarDivider />
              <NotificationsSidebarItem />
              <SidebarDivider />
              <SidebarGroup>
                {bottomItems.map(item => (
                  <SidebarItem
                    key={item.to}
                    icon={item.icon}
                    to={item.to}
                    text={item.text}
                  />
                ))}
              </SidebarGroup>
            </Sidebar>
          );
        },
      },
    }),
  ],
});
